import React from 'react';
import { Link } from 'react-router-dom';
const SaasPromoBanner: React.FC = () => {
  return <div className="text-center textmd text-gray-600 border-t pt-4 w-full py-[18px] bg-slate-300">
      Looking to start your own referral program service business?{' '}
      
    </div>;
};
export default SaasPromoBanner;